export default __webpack_public_path__ + "static/media/OracaoPlay_Logo_HighRes.75a88aa0.png";